(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ecomativesby-collection-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ecomativesby-collection-product')) {
    class EcomativesbyCollectionProduct extends HTMLElement {
      connectedCallback() {
        this.handle = new URL(window.location.href).searchParams.get('ecomativesby')?.trim().toLowerCase();

        if (!this.handle) {
          return;
        }

        this.onFacetUpdate = this.preserveEcomativesby.bind(this);
        document.addEventListener('facet:update', this.onFacetUpdate, true);

        this.list = this.closest('.shopify-section')?.querySelector('product-list[id^="product-list-"]');

        if (!this.list) {
          return;
        }

        this.observer = new MutationObserver(() => this.promoteWithoutDuplicates());
        this.observer.observe(this.list, { childList: true });

        if (!this.promoteWithoutDuplicates()) {
          this.loadProduct();
        }
      }

      disconnectedCallback() {
        if (this.onFacetUpdate) {
          document.removeEventListener('facet:update', this.onFacetUpdate, true);
        }

        this.observer?.disconnect();
      }

      preserveEcomativesby(event) {
        if (event.detail?.url instanceof URL) {
          event.detail.url.searchParams.set('ecomativesby', this.handle);
        }
      }

      matchingCards() {
        return Array.from(this.list.children).filter((card) => {
          return card.matches('product-card') && card.getAttribute('handle')?.toLowerCase() === this.handle;
        });
      }

      promoteWithoutDuplicates() {
        const matches = this.matchingCards();

        if (matches.length === 0) {
          return false;
        }

        const promotedCard = matches.find((card) => card.hasAttribute('data-ecomativesby-promoted')) || matches[0];

        promotedCard.setAttribute('data-ecomativesby-promoted', '');

        matches.forEach((card) => {
          if (card !== promotedCard) {
            card.remove();
          }
        });

        if (this.list.firstElementChild !== promotedCard) {
          this.list.prepend(promotedCard);
        }

        return true;
      }

      async loadProduct() {
        try {
          const productUrl = new URL(`${window.Shopify.routes.root}products/${encodeURIComponent(this.handle)}`, window.location.origin);
          productUrl.searchParams.set('section_id', 'ecomativesby-product');

          const response = await fetch(productUrl.toString());

          if (!response.ok || !this.isConnected || this.promoteWithoutDuplicates()) {
            return;
          }

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const templateSelector = this.dataset.hideProductInformation === 'true'
            ? 'template[data-hide-product-information="true"]'
            : 'template[data-hide-product-information="false"]';
          const productCard = documentFragment.querySelector(templateSelector)?.content.querySelector('product-card');

          if (!productCard || productCard.getAttribute('handle')?.toLowerCase() !== this.handle) {
            return;
          }

          productCard.setAttribute('data-ecomativesby-promoted', '');
          this.list.prepend(document.importNode(productCard, true));
          this.promoteWithoutDuplicates();
        } catch (error) {
          return;
        }
      }
    }

    customElements.define('ecomativesby-collection-product', EcomativesbyCollectionProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
